const updateColorPalette = (canvasState, command) => canvasState.set('colorPalette', command.get('colorPalette'));

export default updateColorPalette;
